var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBackButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 0C5.38323 0 0 5.38323 0 12C0 18.6168 5.38323 24 12 24C18.6168 24 24 18.6168 24 12C24 5.38323 18.6168 0 12 0ZM12 22.4461C6.23996 22.4461 1.55398 17.7598 1.55398 12C1.55398 6.24022 6.23996 1.55398 12 1.55398C17.76 1.55398 22.4461 6.24022 22.4461 12C22.4461 17.7598 17.76 22.4461 12 22.4461ZM17.8273 10.5092L9.94139 10.5092C9.94139 10.5092 11.853 8.59736 13.0372 7.41373C13.5427 6.90794 13.5427 6.08795 13.0372 5.58215C12.9538 5.49875 12.8693 5.41459 12.7859 5.33119C12.2804 4.82534 11.4604 4.82534 10.9546 5.33119C9.40475 6.88074 6.32921 9.95659 5.25693 11.0291C5.014 11.2717 4.87753 11.6012 4.87753 11.9446V12.0554C4.87753 12.3986 5.014 12.728 5.25693 12.971C6.32921 14.0433 9.40475 17.1191 10.9546 18.6687C11.4604 19.1745 12.2804 19.1745 12.7859 18.6687C12.8693 18.5855 12.9538 18.5008 13.0372 18.4177C13.5427 17.9118 13.5427 17.0921 13.0372 16.5863C11.853 15.4024 9.94139 13.4906 9.94139 13.4906L17.8273 13.4906C18.5426 13.4906 19.1223 12.9107 19.1223 12.1956V11.8042C19.1223 11.0889 18.5426 10.5092 17.8273 10.5092Z",
    fill: "#666E7A"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackButton);
export default __webpack_public_path__ + "static/media/back_button.e9904ce7b6d47a29be550574908aaad8.svg";
export { ForwardRef as ReactComponent };